import { Box, Stack, Tab, Tabs, Typography } from '@mui/material';
import { type SyntheticEvent } from 'react';
import { LandingPageContentTab } from 'src/pages/Settings/memberships/components/landing-page-tab/landing-page-content-tab';
import { LandingPageSettingsTab } from 'src/pages/Settings/memberships/components/landing-page-tab/landing-page-settings-tab';
import { LandingPageTabValues } from 'src/pages/Settings/memberships/types';

interface LandingPageTabsProps {
  readOnly: boolean;
  segmentLogoUrl?: string | null;
  activeTab: LandingPageTabValues;
  onTabChange: (tab: LandingPageTabValues) => void;
}

const TABS: { value: LandingPageTabValues; label: string }[] = [
  { value: LandingPageTabValues.Content, label: 'Content' },
  { value: LandingPageTabValues.Design, label: 'Design' },
  { value: LandingPageTabValues.Settings, label: 'Settings' },
];

const UnderConstruction = () => (
  <Stack alignItems="center" justifyContent="center" py={6} px={2}>
    <Typography variant="body2" color="text.secondary" align="center">
      Under construction.
    </Typography>
  </Stack>
);

export const LandingPageTabs = ({
  readOnly,
  segmentLogoUrl,
  activeTab,
  onTabChange,
}: LandingPageTabsProps) => {
  const handleTabChange = (_: SyntheticEvent, nextTab: LandingPageTabValues) => {
    onTabChange(nextTab);
  };

  return (
    <Stack flex={1} direction="column">
      <Tabs value={activeTab} onChange={handleTabChange} sx={{ px: 2 }}>
        {TABS.map((tab) => (
          <Tab key={tab.value} label={tab.label} value={tab.value} />
        ))}
      </Tabs>

      <Box hidden={activeTab !== LandingPageTabValues.Content}>
        <LandingPageContentTab readOnly={readOnly} />
      </Box>
      <Box hidden={activeTab !== LandingPageTabValues.Settings}>
        <LandingPageSettingsTab readOnly={readOnly} segmentLogoUrl={segmentLogoUrl} />
      </Box>
      <Box hidden={activeTab !== LandingPageTabValues.Design}>
        <UnderConstruction />
      </Box>
    </Stack>
  );
};
